import { createContext } from 'react'

const CamelotContext = createContext();

export const CamelotProvider = CamelotContext.Provider

export default CamelotContext
